  <div class="col-12 md:col-12 lg:col-12">
    <p-panel header="{{ 'INICIO_DASHBOARD.LBL_WIDGETEJECUTIVO' | translate}}">
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-dataView [loading]="carDatos" #dt filterBy="zona,tercero"
                      [value]="lisEjecutivos" emptyMessage="{{ 'MSG_NOHAYREGISTROS' | translate}}"
                      [paginator]="true" [rows]="8" paginatorPosition="bottom">
            <p-header>
              <div class="grid">
                <div class="col-12 md:col-12 lg:col-12">
                  <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                         (input)="dt.filter($event.target.value)">
                </div>
              </div>
            </p-header>
            <ng-template let-row pTemplate="listItem">
              <div class="grid" style="border-bottom: 1px solid #d9d9d9">
                <div class="col-12 md:col-2 lg:col-2 text-center"><i class="fa fa-user-circle-o fa-3x"></i></div>
                <div class="col-12 md:col-8 lg:col-8 col-nopad">
                  <div class="grid">
                    <div class="col-12 md:col-9 lg:col-9">
                      <strong>{{row.tercero}}</strong><br>
                      {{row.zona}}
                    </div>
                    <div class="col-12 md:col-3 lg:col-3">
                      <button icon="fa fa-street-view" label="{{'INICIO_DASHBOARD.BTN_GESTIONAR'  | translate }}"
                              (click)="gestionar(row)"
                              pButton></button>
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-dataView>
        </div>
      </div>
    </p-panel>
  </div>
